import { DefaultResponseWithData } from "./system";
import { IPlannerVehicleRow, VehicleProductionLine } from "./ProductionPlanner";
import { DismantlingBayType } from "./DismantlingBay";
import { VehicleComplexity } from "./Vehicle";
import { PartAssemblyType } from "./Part";

export { PartAssemblyType };

export enum ProductionDashboardBayStatus {
  Available = 0,
  InProgress = 1,
  Complete = 2,
}

export interface IProductionDashboardAssembly {
  name: string;
  type: PartAssemblyType;
}

export interface IBaysInUseKpi {
  used: number;
  total: number;
}

export interface IPartsRemovedBreakdownEntry {
  name: string;
  count: number;
}

export interface IPartsRemovedKpi {
  total: number;
  breakdown: IPartsRemovedBreakdownEntry[];
}

export interface IProductionDashboardKpis {
  baysInUse: IBaysInUseKpi;
  linesInUse: IBaysInUseKpi;
  vehiclesInProgress: number;
  vehiclesDismantledToday: number;
  partsRemoved: IPartsRemovedKpi;
}

export interface IProductionDashboardBayVehicle {
  id: string;
  vrm: string;
  stockNumber: string | null;
  combinedMake: string | null;
  combinedModel: string | null;
  bodyStyle: string | null;
  complexity: VehicleComplexity;
  productionLine: VehicleProductionLine;
  partsRemoved: number;
  partsTotal: number;
  percentComplete: number;
  currentAssemblyName: string | null;
  currentAssemblyIndex: number | null;
  assemblyCount: number;
  currentAssemblyElapsedSeconds: number;
  currentAssemblyStartedOn: string | null;
  currentAssemblyAverageMinutes: number | null;
}

export interface IProductionDashboardBay {
  id: string;
  name: string;
  type: DismantlingBayType;
  line: VehicleProductionLine;
  status: ProductionDashboardBayStatus;
  currentVehicle: IProductionDashboardBayVehicle | null;
  currentVehicles: IProductionDashboardBayVehicle[];
  dueNext: IPlannerVehicleRow[];
}

export interface IProductionDashboardSession {
  id: string;
  vehicleId: string;
  vrm: string | null;
  stockNumber: string | null;
  combinedMake: string | null;
  combinedModel: string | null;
  elapsedSeconds: number;
  startedOn: string | null;
}

export interface IProductionDashboardOverview {
  kpis: IProductionDashboardKpis;
  bays: IProductionDashboardBay[];
  assemblies: IProductionDashboardAssembly[];
  inProgressTriages: IProductionDashboardSession[];
  inProgressDepollutions: IProductionDashboardSession[];
}

export interface IProductionDashboardOverviewResponse
  extends DefaultResponseWithData<IProductionDashboardOverview> {}

export type ProductionDashboardView = "Line" | "Bays";
